import { useHotkeys } from "react-hotkeys-hook"

import { SIDEBAR_TOGGLE_SHORTCUT_KEY } from "#React/constants/KeyboardShortcuts"
import KeyboardShortcut from "#React/ui/KeyboardShortcut"
import { isSidebarCollapsed, toggleSidebarCollapsed } from "#Utils/sidebarCollapse"

const SidebarCollapseToggle = () => {
  const toggleSidebar = (event) => {
    const nextCollapsed = toggleSidebarCollapsed()

    event.stopPropagation()

    if (nextCollapsed) {
      event.currentTarget.blur()
    }
  }

  useHotkeys(
    SIDEBAR_TOGGLE_SHORTCUT_KEY,
    (event) => {
      event.preventDefault()
      toggleSidebarCollapsed()
    },
    {
      enableOnFormTags: false,
      enabled: true,
      enableOnContentEditable: false,
      preventDefault: true,
    },
  )

  return (
    <li className="c-side-nav__section sidebar-collapse-toggle">
      <button
        type="button"
        className="c-side-nav__item js-sidebar-collapse-toggle"
        aria-controls="sidenav"
        aria-expanded={isSidebarCollapsed() ? "false" : "true"}
        aria-label={isSidebarCollapsed() ? "Show menu" : "Hide menu"}
        onClick={toggleSidebar}
      >
        <i className="far fa-fw fa-sidebar c-side-nav__item-icon size-4 min-w-4" />
        <span className="c-side-nav__item-title responsive-hidden">
          <span className="sidebar-collapse-toggle__collapse-label">Hide menu</span>
          <span className="sidebar-collapse-toggle__expand-label">Show menu</span>
        </span>
        <div className="responsive-hidden indent-0">
          <KeyboardShortcut
            shortcut={SIDEBAR_TOGGLE_SHORTCUT_KEY}
            className="c-side-nav__item-icon ml-1"
          />
        </div>
      </button>
    </li>
  )
}

export default SidebarCollapseToggle
